/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetsDeltaResponseModel } from '../../models/patient-targets-delta-response-model';

export interface GetPatientTargetsDelta$Params {
  patientID?: number;
  onlyActive?: boolean;
  sinceCursor?: string;
  lightLoad?: boolean;
}

export function GetPatientTargetsDelta(http: HttpClient, rootUrl: string, params?: GetPatientTargetsDelta$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetsDeltaResponseModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientTargetsDelta.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
    rb.query('sinceCursor', params.sinceCursor, {});
    rb.query('lightLoad', params.lightLoad, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientTargetsDeltaResponseModel>;
    })
  );
}

GetPatientTargetsDelta.PATH = '/api/Supervisor/GetPatientTargetsDelta';
